import React from 'react';
import { Box, useTheme } from '@mui/material';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { SidebarProvider, useSidebar } from '../contexts/SidebarContext';
interface DashboardLayoutProps {
  children: React.ReactNode;
}

const DashboardLayoutContent: React.FC<DashboardLayoutProps> = ({ children }) => {
  const { sidebarOpen, toggleSidebar } = useSidebar();
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#fafafa' }}>
      {/* Navbar */}
      <Navbar />
      
      {/* Sidebar */}
      <Sidebar open={sidebarOpen} onToggle={toggleSidebar} />
      
      {/* Main Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            mt: '64px', // below navbar
            ml: 0, // Keep this at 0 to connect sidebar with page content
            backgroundColor: '#fafafa',
            height: 'calc(100vh - 64px)', // Fixed height instead of minHeight
            display: 'flex',
            p: 0,
            overflow: 'auto', // Allow main container scrolling
            // Custom scrollbar styling
            '&::-webkit-scrollbar': {
              width: '12px',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: 'transparent',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#c1c1c1',
              borderRadius: '6px',
              margin: '0px',
              border: '2px solid transparent',
              backgroundClip: 'content-box',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#a8a8a8',
            },
            scrollbarColor: '#c1c1c1 transparent',
            scrollbarWidth: 'thin',
            transition: theme.transitions.create(['margin'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
          }}
        >
          <Box sx={{ flexGrow: 1, width: '100%', height: '100%', overflow: 'visible' }}>
            {children}
          </Box>
        </Box>
    </Box>
  );
};

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <SidebarProvider>
      <DashboardLayoutContent>{children}</DashboardLayoutContent>
    </SidebarProvider>
  );
};

export default DashboardLayout;